<template>
  <section class="relative z-2 -mt-8 rounded-t-[40px] bg-white py-20 md:py-28">
    <DefaultGrid class="gap-y-12 md:gap-y-16">
      <div class="col-span-full text-center">
        <h2
          class="type-font-salt-ss02 text-[56px] leading-[0.9] font-medium tracking-[-0.03em] md:text-[80px]"
        >
          Resources
        </h2>
      </div>

      <div class="col-span-full">
        <div class="grid gap-6 lg:grid-cols-2 lg:grid-rows-2">
          <!-- Feature card -->
          <NuxtLink
            v-if="featureArticle"
            :to="`/resources/${featureArticle.slug}`"
            class="bg-blue relative flex flex-col overflow-hidden rounded-[20px] p-8 lg:row-span-2"
          >
            <h3
              class="type-heading-4 max-w-sm font-medium"
              v-text="featureArticle.title"
            />
            <div class="relative my-8 flex grow items-center justify-center">
              <img
                src="/images/background-fireworks.svg"
                alt=""
                class="pointer-events-none absolute w-[480px] max-w-none opacity-40"
              />
              <div
                class="relative size-[200px] max-w-full rotate-[5deg] overflow-hidden rounded-[22px] md:size-[308px]"
              >
                <PayloadImage
                  class="h-full w-full object-cover"
                  :image="featureArticle.image"
                  :sizes="{ default: '90vw', lg: '308px' }"
                />
              </div>
            </div>
            <span
              class="flex h-13 w-13 items-center justify-center rounded-full bg-white/50"
            >
              <SvgGlyphArrowRight class="h-5 w-5" />
            </span>
          </NuxtLink>

          <!-- Article cards -->
          <NuxtLink
            v-for="article in articles"
            :key="article.id"
            :to="`/resources/${article.slug}`"
            class="bg-grey flex flex-col overflow-hidden rounded-[20px] md:flex-row"
          >
            <div
              class="aspect-[2/1] w-full flex-none overflow-hidden md:aspect-square md:w-1/2 md:self-stretch"
            >
              <PayloadImage
                class="h-full w-full object-cover"
                :image="article.image"
                :sizes="{ default: '100vw', md: '50vw', lg: '325px' }"
              />
            </div>
            <div class="flex grow flex-col p-6">
              <span
                class="flex h-6 items-center self-start rounded-[20px] border border-black/10 px-3 text-[13px] font-medium"
                v-text="
                  $dayjs(article.publishedAt || article.createdAt).format(
                    'D MMMM YYYY',
                  )
                "
              />
              <h3
                class="type-heading-5 mt-4 font-medium"
                v-text="article.title"
              />
              <span
                class="mt-auto flex h-13 w-13 items-center justify-center rounded-full bg-white"
              >
                <SvgGlyphArrowRight class="h-5 w-5" />
              </span>
            </div>
          </NuxtLink>
        </div>
      </div>

      <div class="col-span-full flex justify-center">
        <NuxtLink to="/resources" class="btn btn-sm btn-yellow">
          View more
        </NuxtLink>
      </div>
    </DefaultGrid>
  </section>
</template>

<script setup lang="ts">
import type { ResourceArticle } from '#payload-types'

interface Props {
  // The latest article from a category that does not show dates.
  featureArticle?: ResourceArticle | null
  // The latest articles from the categories that do show dates.
  articles?: ResourceArticle[]
}

withDefaults(defineProps<Props>(), {
  featureArticle: null,
  articles: () => [],
})
</script>
